import clsx from "clsx"
import React, { type JSX } from "react"

import Button from "@/ui/components/Button"
import PageGrid from "@/ui/components/PageGrid"

export type GlobalPencilBannerProps = React.ComponentPropsWithoutRef<"div"> & {
  copy: React.ReactNode
  buttonAttrs: React.ComponentProps<typeof Button>
  backgroundLayout?: React.ReactNode
}

const GlobalPencilBanner: React.FC<GlobalPencilBannerProps> = (props) => {
  const {
    copy,
    className = "text-white-100",
    id = "globalPencilBanner",
    buttonAttrs,
    backgroundLayout,
    ...restOfHtmlAttrs
  } = props

  return (
    <div
      id={id}
      className={clsx(
        "relative overflow-hidden z-9999 bg-newblue-90 text-white-100 max-h-[86px] md:h-16",
        className,
      )}
      {...restOfHtmlAttrs}
      role="banner"
    >
      {/* Background layout - positioned absolutely within the relative container */}
      {backgroundLayout}
      <PageGrid
        isGrid={false}
        className="relative z-10 flex flex-col items-center justify-center px-4 py-3 text-center md:flex-row md:justify-center md:items-center md:py-4"
      >
        <div className="mb-2 md:mb-[5px] md:mr-4">
          <p className="font-[700] uppercase tracking-wider md:text-base text-[14px]">
            {copy}
          </p>
        </div>
        <div className="flex-shrink-0">
          <Button variant="primary" {...buttonAttrs} size="sm" />
        </div>
      </PageGrid>
    </div>
  )
}

export default GlobalPencilBanner
